import { render, staticRenderFns } from "./shuziganbo.vue?vue&type=template&id=d788eb2e&scoped=true&"
import script from "./shuziganbo.vue?vue&type=script&lang=js&"
export * from "./shuziganbo.vue?vue&type=script&lang=js&"
import style0 from "./shuziganbo.vue?vue&type=style&index=0&id=d788eb2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d788eb2e",
  null
  
)

export default component.exports